import * as React from 'react'

import {
  Box,
  Button,
  Typography,
  InputAdornment,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  Paper,
  Chip
} from '@mui/material'

import { useDispatch, useSelector } from 'react-redux';

import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import RoomPreferencesOutlinedIcon from '@mui/icons-material/RoomPreferencesOutlined';

import { CTextField } from '../../components/common/TextField';
import { CActionButton, CPageButton, CPageArrowButton } from '../../components/common/Button'
import GroupModal from '../../modals/admin/GroupModal';
import AssignSourceModal from '../../modals/admin/AssignSourceModal';
import AssignUserModal from '../../modals/admin/AssignUserModal';

import { getGroups, deleteGroup } from '../../slices/group';
import { getKey } from '../../slices/utils';
function Group() {
  const [openGroup, setOpenGroup] = React.useState(false);
  const [openSourceAssign, setOpenSourceAssign] = React.useState(false);
  const [openUserAssign, setOpenUserAssign] = React.useState(false);
  const [groupName, setGroupName] = React.useState('');
  const [defaultAssign, setDefaultAssign] = React.useState([]);
  const [type, setType] = React.useState('');

  const defaultKey = useSelector(state => state.utils.key);
  const [groupData, setGroupData] = React.useState({name: '', apiKey: defaultKey});
  const [mode, setMode] = React.useState('Create');
  const dispatch = useDispatch();
  const groups = useSelector(state => state.group.groups);

  React.useEffect(() => {
    if(defaultKey === '')
      dispatch(getKey())
      .then(res => {
        setGroupData({name: '', apiKey: res.payload})
      })
      .catch(err => console.log(err));

    let formData = new FormData();
    formData.append("page", 1);
    dispatch(getGroups(formData));
  }, [dispatch])

  const handleOpenNewGroup = (e) => {
    setOpenGroup(true);
    setMode('Create');
  }

  const handleCloseNewGroup = (e) => {
    setOpenGroup(false);
  }

  const handleEdit = (info) => {
    setGroupData(info);
    setMode('Update');
    setOpenGroup(true);
  }

  const handleDelete = (id) => {
    dispatch(deleteGroup(id))
      .then(res => window.alert("DELETE OK"))
      .catch(err => console.log(err))
  }
  
  const handleAssign = (name, type) => {
    setGroupName(name);
    setType(type);
    for(const group of groups) {
      const {name: gname, sources, users} = group;
      if(gname === name) {
        if(type === 'User')
          setDefaultAssign(users)
        else
          setDefaultAssign(sources)
      }
    }
    if(type === 'User') {
      setOpenUserAssign(true);
    } else {
      setOpenSourceAssign(true);
    }
  }
  
  const handleCloseSourceAssign = (e) => {
    setOpenSourceAssign(false);
  }

  const handleCloseUserAssign = (e) => {
    setOpenUserAssign(false);
  }

  return (
    <Box className='w-full flex flex-column flex-basis flex-gap' >
      <Box sx={{paddingTop: 2, paddingLeft: 2}}>
        <Typography 
          sx={{ 
            fontSize: 24, 
            fontWeight: 600, 
            color: '#4A85F6'
          }}
        >
          Group
        </Typography>
      </Box>
      <Box sx={{paddingTop: 2, gap: 2}} className='flex flex-row align-center'>
        <CTextField
          label=""
          id="search-text-field"
          placeholder='Search'
          sx={{ m: 1, flex: 1, background: 'white'}}
          InputProps={{
            startAdornment: <InputAdornment position="start"><SearchOutlinedIcon /></InputAdornment>,
          }}
        />
        <Button
          sx={{
            textTransform: 'none',
            height: 54,
            borderRadius: 2
          }}
          endIcon={<AddIcon />}
          variant='contained'
          onClick={handleOpenNewGroup}
        >
          Add New Group
        </Button>
      </Box>
      <Box className='flex-basis'>
        <Paper className='h-full flex flex-column' sx={{borderRadius: 4, margin: 1}}>
          <TableContainer className='flex-basis'>
            <Table sx={{ minWidth: 650, height: '100%' }} size="small" aria-label="a dense table">
              <TableHead sx={{ height: 64}}>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Create Date</TableCell>
                  <TableCell sx={{width: 150}}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.from({ length: 10 }).map((_, i) => {
                  const group = groups[i];
                  return (
                    <TableRow
                      key={group ? group.id : 1000000+i}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50 }}
                    >
                      {group ? (
                        <>
                          <TableCell component="th" scope="row">
                            {group.name}
                          </TableCell>
                          <TableCell>{group.created_at}</TableCell>
                          <TableCell>
                            <CActionButton 
                              startIcon={<BorderColorIcon/>}
                              onClick={() => handleEdit({id: group.id, name: group.name, apiKey: group.api_key})}
                            />
                            <CActionButton 
                              startIcon={<ManageAccountsOutlinedIcon/>}
                              onClick={() => handleAssign(group.name, 'User')}
                            />
                            <CActionButton 
                              startIcon={<RoomPreferencesOutlinedIcon/>}
                              onClick={() => handleAssign(group.name, 'Source')}
                            />
                            <CActionButton 
                              startIcon={<DeleteOutlineIcon/>}
                              onClick={() => handleDelete(group.id)}
                            />
                          </TableCell>
                        </>
                      ) : (
                        // Render empty cells for blank rows
                        <>
                          {/* <TableCell component="th" scope="row" sx={{borderBottom: 'none'}}></TableCell> */}
                          <TableCell sx={{borderBottom: 'none'}}></TableCell>
                          <TableCell sx={{borderBottom: 'none'}}></TableCell>
                        </>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              height: 80,
              paddingLeft: 8,
              paddingRight: 8,
              borderTop: '1px solid rgba(224, 224, 224, 1)'
            }}
            className='flex flex-row align-center justify-between'
          >
            <CPageArrowButton startIcon={<ArrowBackIcon/>} >Previous</CPageArrowButton>
            <Box sx={{color: '#f5f5f5'}}>
              <CPageButton sx={{border: '1px solid #f1f1f1'}}>1</CPageButton>
              <CPageButton>2</CPageButton>
              <CPageButton>3</CPageButton>
              <CPageButton>...</CPageButton>
              <CPageButton>8</CPageButton>
              <CPageButton>9</CPageButton>
              <CPageButton>10</CPageButton>
            </Box>
            <CPageArrowButton endIcon={<ArrowForwardIcon/>} >Next</CPageArrowButton>
          </Box>
        </Paper>
      </Box>
      <GroupModal open={openGroup} mode={mode} data={groupData} handleClose={handleCloseNewGroup} />
      <AssignSourceModal open={openSourceAssign} group={groupName} defaultValue={defaultAssign} type={type} handleClose={handleCloseSourceAssign} />
      <AssignUserModal open={openUserAssign} group={groupName} defaultValue={defaultAssign} type={type} handleClose={handleCloseUserAssign} />
    </Box>
  );
}

export default Group;